export default "__VITE_ASSET__348607e7__"